import React, { useEffect } from "react";
import PricingSection from "bundles/LandingPageRecruiter/components/landing_page/PricingSection";
import trackEvent from "bundles/common/utils/trackEvent";

const PricingPage = () => {
  useEffect(() => {
    trackEvent("billing", "pricing_viewed");
  }, []);

  return <PricingSection useMailto showPrices />;
};

export default PricingPage;
